export default __webpack_public_path__ + "static/media/icon_checkmark.74961850.svg";